<template>
  <vs-tabs>
    <vs-tab label="사업장 등록" @click="onClickTab(0)">
      <vx-card>
        <div>
          <div class="flex justify-between items-center">
            <p style="font-size: 18px; font-weight: 700">사업장 등록</p>
            <div class="flex justify-end">
              <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
              <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
            </div>
          </div>
          <p class="title mt-5 mb-5">사업장 정보</p>
          <div class="writeGridContainer">
            <div>
              <div>사업장명</div>
              <ml-input v-model="form.field_name" />
            </div>
            <div>
              <div>담당 주무관</div>
              <ml-input v-model="form.manager_name" />
            </div>
            <div>
              <div>사업기간</div>
              <date-selector-rang :value="{ sDate: form.work_begin_at, eDate: form.work_end_at }" @sDate="form.work_begin_at = $event" @eDate="form.work_end_at = $event" />
            </div>

            <div>
              <div>사업금액(원)</div>
              <comma-input v-model="form.deposit_amount" />
            </div>
            <div>
              <div>사업장 주소</div>
              <ml-input v-model="form.address" />
            </div>
            <div>
              <div>사업장 연락처</div>
              <ml-input v-model="form.phone" />
            </div>

            <div>
              <div>구분</div>
              <vs-select class="w-full" autocomplete v-model="cat1" @change="onChangeCat1">
                <vs-select-item v-for="option in cat1List" :key="option.cat1" :text="option.cat1" :value="option.cat1" />
              </vs-select>
            </div>
            <div>
              <div>종류</div>
              <vs-select class="w-full" autocomplete v-model="cat2" @change="onChangeCat2">
                <vs-select-item v-for="option in cat2List" :key="option.cat2" :text="option.cat2" :value="option.cat2" />
              </vs-select>
            </div>
            <div>
              <div>세분류</div>
              <vs-select class="w-full" autocomplete v-model="cat3" @change="onChangeCat3">
                <vs-select-item v-for="option in cat3List" :key="option.cat3" :text="option.cat3" :value="option.id" />
              </vs-select>
            </div>

            <div>
              <div>현장소장</div>
              <ml-input v-model="form.director_name" />
            </div>
            <div>
              <div>안전관리자</div>
              <ml-input v-model="form.safety_manager_name" />
            </div>
            <div>
              <div>계약번호</div>
              <ml-input v-model="form.contract_code" />
            </div>
          </div>
        </div>

        <!-- 담당 부서 및 수급업체 현황 -->
        <company-add-module v-model="companyList" @remove="removeCompany" />

        <!-- 참여 인원 정보 -->
        <company-user-auth-module
          :colData="[
            { head: '구분', key: 'company_id' },
            { head: '사용자명', key: 'name' },
            { head: '연락처', key: 'phone' },
          ]"
          :users="userList"
          v-model="joinUsers"
        />

        <div class="my-8" style="display: grid; grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
          <div>
            <p class="title-n">현장조감도</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_view" />
          </div>
          <div>
            <p class="title-n">현장약도</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_map" />
          </div>
          <div>
            <p class="title-n">현장사진</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_photo" />
          </div>
        </div>

        <file-upload-module v-model="fileList" />
      </vx-card>
    </vs-tab>
    <vs-tab label="사업장 현황" @click="onClickTab(1)"></vs-tab>
  </vs-tabs>
</template>

<script>
import FileInput from "@/components/custom/FileInput";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/views/list/components/SearchNavStartEnd";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";

export default {
  components: {
    DateSelector,
    SearchNavStartEnd,
    CompanyUserAuthModule,
    CompanyAddModule,
    FileUploader,
    FileInput,
    FileUploadModule,
    DateSelectorRang,
  },
  data() {
    return {
      form: {
        field_name: "", // 사업장명
        manager_name: "", // 담당 주무관
        work_begin_at: "", // 사업기간
        work_end_at: "", // 사업기간

        deposit_amount: "", // 사업금액
        address: "", // 사업장 주소
        phone: "", // 사업장 연락처

        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 완료
        company_ids: [], // 참여 업체 목록
        user_ids: [], // 참여 사용자 목록

        field_view: {}, // 현장 조감도
        field_map: {}, // 현장 약도
        field_photo: {}, // 현장 사진
        start_work_at: "",
        be_completed_at: "",

        facility_category_id: "",
        meta: "", // 부가 정보

        director_name: "",
        safety_manager_name: "",
        safety_grade: "",
        format: "",
        scale1: "",
        scale2: "",
        scale3: "",
        contract_code: "",
      },
      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      cat1: "",
      cat2: "",
      cat3: "",
      cat1List: [],
      cat2List: [],
      cat3List: [],
    };
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    this.initBreadcrumb();
  },
  async mounted() {
    await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", {});
    this.cat1List = this.$store.state.project.fieldFacilityCategoryOptions;

    if (this.postId) {
      await this.loadField();
    }
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "사업장 현황" }, { title: "발주 사업장", active: true }]);
    },
    async loadField() {
      const postId = this.postId;
      await this.$store.dispatch("project/LOAD_FIELD", { postId });
      const info = this.$store.state.project.fieldInfo;
      this.joinUsers = info.users;
      this.form = { ...info };

      if (this.form.start_work_at) this.form.start_work_at = new Date(this.form.start_work_at).format("yyyy-MM-dd");
      if (this.form.be_completed_at) this.form.be_completed_at = new Date(this.form.be_completed_at).format("yyyy-MM-dd");

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      if (this.form.facility_category) {
        this.cat1 = this.form.facility_category.cat1;
        this.cat2 = this.form.facility_category.cat2;
        this.cat3 = this.form.facility_category.id;
      }

      if (this.form.companies && this.form.companies.length > 0) {
        const companies = [];
        for (const company of this.form.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-field-list" });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "field-field-info" });
      }
    },
    onClickSave() {
      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      if (this.postId) {
        // update
        const fieldId = this.postId;
        this.$store
          .dispatch("project/UPDATE_FIELD", {
            field_type: "사업장(도급발주)",
            fieldId,
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      } else {
        // create
        this.$store
          .dispatch("project/CREATE_FIELD", {
            field_type: "사업장(도급발주)",
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      }
    },
    onClickMoveList() {
      this.$router.push({ name: "field-field-list" });
    },
    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },
    handleSearch(/*searching*/) {},
    handleSort(/*key, active*/) {},
    async onChangeCat1(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: data });
        this.cat2List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    async onChangeCat2(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.cat1, cat2: data });
        this.cat3List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    onChangeCat3(data) {
      this.form.facility_category_id = data;
    },
  },
};
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
